<prf-section>
  <prf-h2 class="prf-information-for-different-users-title">{{ informationForDifferentUsers.title }}</prf-h2>
  <prf-description class="prf-information-for-different-users-description">{{ informationForDifferentUsers.description }}</prf-description>
  <div class="prf-information-for-different-users-cards">
    @for (card of informationForDifferentUsers.cards; track card.id) {
      <prf-information-for-different-users-card [card]="card" />
    }
  </div>
</prf-section>
